import { UserRole } from "@/shared/enums/UserRolesEnums";
import PrivateCoachingList from "@/views/App/Analytics/BillingForecast/Billing/PrivateCoaching/List.vue";
import AssistedLivingCoachingList from "@/views/App/Analytics/BillingForecast/Billing/AssistedLivingCoaching/List.vue";
import SocioTherapyCoachingList from "@/views/App/Analytics/BillingForecast/Billing/SocioTherapyCoaching/List.vue";
import TotalValues from "@/views/App/Analytics/BillingForecast/Billing/Totals/Totals.vue";

import PrivateCoachingCoachBillingList from "@/views/App/Analytics/BillingForecast/CoachBilling/PrivateCoaching/List.vue";

const routesAnalyticsBillingForecast = [
    // Billing
    {
        path: "billing-forecast/private-coaching",
        name: "analyticsBillingForecastPrivateCoachingList",
        component: PrivateCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "billing-forecast/socio-therapy-coaching/list",
        name: "analyticsBillingForecastSocioTherapyCoachingList",
        component: SocioTherapyCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "billing-forecast/assisted-living-coaching/list",
        name: "analyticsBillingForecastAssistedLivingCoachingList",
        component: AssistedLivingCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "billing-forecast/total-values",
        name: "analyticsBillingForecastTotalValues",
        component: TotalValues,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },

    // Coach billing
    {
        path: "coach-billing-forecast/private-coaching",
        name: "analyticsCoachBillingForecastPrivateCoachingList",
        component: PrivateCoachingCoachBillingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
  ]

export default routesAnalyticsBillingForecast;